import {RouteDefinition} from '../../../routes';
import React, {memo} from 'react';
import {PasswordContainer} from '../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../components/Settings/SettingsPageContainer';

// todo gecici (don't forget tsx -> ts)
export const LanguageSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Language',
        routerLink: '/settings/language',
        component: memo(
            () => {
                return (
                    <>
                        <PasswordContainer requiredRole="user" isFullscreen={true}>
                            <SettingsPageContainer buttons={[]} backUrl={'/settings'}/>
                        </PasswordContainer>
                    </>
                );
            }),
    },
];
